/**
 * Bridge between `SelectSearch`'s generic eyedropper callback shape and the
 * store's `beginEyedropperSession`, resolving object ids to display names so
 * fields storing a `targetObjectName`-style string can be populated by
 * clicking a scene object.
 *
 * Usage: pass directly as the `eyedropperPick` prop of `<SelectSearch>`.
 */

import { useStore } from "../app/store.ts";
import type { SceneObject } from "../modeling/types.ts";

export function beginSceneObjectNameEyedropper(
  onPick: (name: string) => void,
  onCancel: () => void,
  canPickObject?: (obj: SceneObject) => boolean,
): void {
  const canPickId = (id: string): boolean => {
    const obj = useStore.getState().sceneObjects.get(id);
    return !!obj && (!canPickObject || canPickObject(obj));
  };
  useStore.getState().beginEyedropperSession(
    (id) => {
      const obj = useStore.getState().sceneObjects.get(id);
      if (obj && (!canPickObject || canPickObject(obj))) {
        onPick(obj.name);
      }
    },
    onCancel,
    canPickId,
  );
}
